import { QuestionScore } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

/**
 * this calculation simply returns the grading weight for a given question.
 * Regardless of whether or not it is possible to receive those points.
 *
 * **Use this function if you are not calculationg a total**
 */
export const assignedGradingWeight = ({
  question,
  questionScore = null,
}: {
  question: QuizQuestion;
  questionScore?: QuestionScore;
}) => questionScore?.gradingWeight ?? question?.gradingWeight;
